export enum TouchPointStatus{
"Completed" = 0,
"Missing" = 1,
"Failing" = 2,
"AdHoc" = 3
}
  